<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { text: $t('dashboardVue.dashboard'), link: 'welcome' },
        { text: 'Məhsullar və Xidmətlərim', link: 'myProductsPage'},
        { text: 'Bütün məhsullarım', link: '',active: true },
      ]"
    />

    <div
      class="container mt-4"
      style="max-width: 1700px"
    >
      <div class="row">
        <!-- Main Content -->
        <div class="col-xl-8">
          <!-- Add New Product Button -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3>Bütün məhsullarım və xidmətlərim</h3>
            <button
              class="btn btn-outline-primary"
              @click.prevent="$router.push({ name: 'newProductOrServicePage' })"
            >
              <i class="fa fa-plus" /> Yeni məhsul və xidmət yarat
            </button>
          </div>

          <!-- Product Cards -->
          <div class="row">
            <!-- Product Grid -->
            <div
              v-for="product in products"
              :key="product.id"
              class="col-md-6 col-lg-4 mb-4 d-flex align-items-stretch"
            >
              <div
                class="card w-100"
                @click.prevent="$router.push({ name: 'product', params: { id: product.id } })"
              >
                <div class="card-body text-center d-flex flex-column">
                  <img
                    :src="mediaBase + product.coverPhotoUrl"
                    class="img-fluid mb-3 product-image"
                    alt="Product"
                  >
                  <h5 class="card-title mb-2 product-title">
                    {{ product.name }}
                  </h5>
                  <div class="company-name">
                    {{ product.company.name }}
                  </div>
                  <div>
                    <div
                      v-if="product.hasActiveAdvertisement"
                      class="advertisement-indicator"
                    >
                      Advertisement Active
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid ends-->
    </div>
    <!-- Container-fluid starts-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mediaBase } from "@/repositories/Repository";
import { getProducts } from "@/repositories/ProductDataRepository";

export default {
  components: {},
  data() {
    return {
      mediaBase: mediaBase,
      products: [],
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
      userPackageStatus: (state) => state.auth.userPackageStatus,
      userPackage: (state) => state.auth.userPackage,
    }),
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      getProducts(this.token).then((data) => {
        if (data.code === 200) {
          this.products = data.products.map(product => ({
            ...product,
            hasActiveAdvertisement: product.hasActiveAdvertisement || false // Ensure the property exists
          }));
        }
      });
    },
  },
};
</script>

<style scoped>
.card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.product-title, .company-name {
  width: 100%;
  text-align: left;
}

.product-title {
  font-size: 18px;
  margin-bottom: 10px;
}

.company-name {
  font-size: 14px;
  color: #6c757d;
}

.card {
  height: 100%;
}

.advertisement-indicator {
  background-color: #ffc107;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;
}
</style>
